import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import ApiConnect from "../../../Utils/ApiConnect";
import { Bar } from "react-chartjs-2";
class Report extends Component {
  constructor() {
    super();
    this.state = {
      Fetchdata: [],
      loading: true,
      startDate: new Date(),
      endDate: new Date(),
      waiter: "",
      WaiterList: [],
      Bardata: "",
    };
    this.columns = [
      {
        key: "product",
        text: "Product Name",
        sortable: true,
      },
      {
        key: "category",
        text: "Category",
        sortable: true,
      },
      {
        key: "order",
        text: "Complete Order",
        sortable: true,
      },
      {
        key: "modify",
        text: "Modify Order",
        sortable: true,
      },
      {
        key: "delete",
        text: "Delete/Canceled order",
        sortable: true,
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        excel: false,
        print: false,
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  waiterListFetch = () => {
    ApiConnect.get("POS/Orders/WaiterList")
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ WaiterList: response.data.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  componentDidMount() {
    this.waiterListFetch();
  }
  FetchKitchenReport = () => {
    this.setState({ loading: true });
    ApiConnect.get(
      `POS/Orders/Report?from=${format(
        this.state.startDate,
        "yyyy-MM-dd"
      )}&to=${format(
        this.state.endDate,
        "yyyy-MM-dd"
      )}&location=kitchen,bar&waiter=${this.state.waiter}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            Fetchdata: response.data.data,
            loading: false,
            Bardata: {
              labels: response.data.data.map((p) => p.product),
              datasets: [
                {
                  label: "Complete",
                  data: response.data.data.map((p) => parseInt(p.order)),
                  backgroundColor: "rgb(75, 192, 192)",
                },
                {
                  label: "Modify",
                  data: response.data.data.map((p) => parseInt(p.modify)),
                  backgroundColor: "rgb(255, 206, 86)",
                },
                {
                  label: "Delete",
                  data: response.data.data.map((p) => parseInt(p.delete)),
                  backgroundColor: "rgb(255, 99, 132 )",
                },
              ],
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="container">
        <div className="card">
          <div className="card-header">
            <div className="input-group">
              <label htmlFor="start">From Date</label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={new Date()}
                closeOnScroll={true}
                selected={this.state.startDate}
                value={this.state.startDate}
                onChange={(e) => this.setState({ startDate: e })}
                placeholderText="Start Date"
              />
            </div>
            <div className="input-group">
              <label htmlFor="start">To Date</label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={new Date()}
                closeOnScroll={true}
                selected={this.state.endDate}
                value={this.state.endDate}
                onChange={(e) => this.setState({ endDate: e })}
                placeholderText="End Date"
              />
            </div>
            <div className="input-group">
              <label htmlFor="waiter">Waiter</label>
              <select
                className="form-control"
                name="waiter"
                onChange={(e) => {
                  this.setState({ waiter: e.target.value });
                }}
              >
                <option value="">Select Waiter</option>
                {this.state.WaiterList
                  ? this.state.WaiterList.map((waiter, index) => (
                      <option value={waiter.id} key={index}>
                        {waiter.name}
                      </option>
                    ))
                  : ""}
              </select>
            </div>

            <button
              className="btn btn-info"
              onClick={(e) => this.FetchKitchenReport()}
            >
              Fetch
            </button>
          </div>

          <div className="card-body">
            <div className="col-md-12">
              {!this.state.loading ? (
                <React.Fragment>
                  <Bar height={"120vh"} data={this.state.Bardata} />
                  <hr />
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            {!this.state.loading ? (
              <ReactDatatable
                className="table"
                config={this.config}
                records={this.state.Fetchdata}
                columns={this.columns}
                loading={this.state.loading}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Report;
